import React from 'react';

export type CloseProps = {
  /** onClick function */
  onClick: (event) => void;
  /** Any additional classes to apply to this specific */
  className?: string;
  /** background color class div */
  bgClassName?: string;
  /** color class */
  color?: string;
};

export function Close({
  onClick,
  className,
  bgClassName,
  color,
  ...props
}: CloseProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {

  const ariaLabel = props['aria-label'] || 'Close';
  delete props['aria-label'];

  const buttonClasses = ['btn-reset flex flex-centered touch-space height-md-all width-md-all absolute'];
  if (bgClassName) {
    buttonClasses.push('top6 right6');
  } else {
    buttonClasses.push('top-6 right');
  }
  className && buttonClasses.push(className);

  const spanClasses = ['flex icon-close height-md-all width-md-all'];
  if (bgClassName) {
    spanClasses.push('round');
    spanClasses.push(bgClassName);
  }

  if(color) spanClasses.push(color);

  return (
    <button {...props}
      aria-label={ariaLabel}
      className={buttonClasses.join(' ')}
      onClick={onClick}
    >
      <span className={spanClasses.join(' ')}/>
    </button>
  );

}